import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link, useParams} from 'react-router-dom';
import styles from "../css/ConfirmationMessage.module.css";
const ConfirmationMessage = () => {
    const [isApplied, setIsApplied] = useState(true);    
    const navigate = useNavigate();
    const { id } = useParams(); // Access job ID from the URL

    const closeDialog = () => {
        setIsApplied(false);
        navigate('/dashboard');
      };
    return (
        <div className={styles.confirmationMessageContainer}>            
            {isApplied && (
                <div className="dialog-box">
                    <h2>Application Submitted Successfully!</h2>
                    <p>Thank you for applying! Your application has been received and 
                        is currently under review. We'll be in touch soon with further 
                        updates. Good luck!</p>
                    <button className={styles.closeButton} onClick={closeDialog}>Close</button>
                </div>
            )}
        </div>
    );
};

export default ConfirmationMessage;